/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationStore } from '../../axios/organisationStore'
import type {
	OrganisationStoreError,
	OrganisationStoreRequest,
	OrganisationStoreResponse,
} from '../../types/OrganisationStore'

export const organisationStoreMutationKey = () => [{ url: '/organisations' }] as const

export type OrganisationStoreMutationKey = ReturnType<typeof organisationStoreMutationKey>

export type OrganisationStoreVariables = {
	data: OrganisationStoreRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::store */
export function useOrganisationStore<TContext = unknown>(
	options?: UseMutationOptions<
		OrganisationStoreResponse,
		AxiosError<OrganisationStoreError>,
		OrganisationStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: organisationStoreMutationKey(),
		mutationFn: ({ data }: OrganisationStoreVariables) => organisationStore(data, config).then(res => res.data),
		...options,
	})
}
